module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_lp/logo_dummy-e54ba921e9651974e2df53d3994625ce.svg";